import Icon from './icon'

Icon.install = (Vue) => {
  Vue.component(Icon.name, Icon)
}

export default Icon
